/**
 * Error thrown when the user calls a method that requires temporal credentials, but they are not present.
 */
export class MissingCredentialsError extends Error {
  constructor() {
    super();
    this.name = "MissingCredentialsError";
  }
}
